module.exports = __webpack_public_path__ + "b882735ab7e34130887d6152bca2fd6a.work4.svg";


//////////////////
// WEBPACK FOOTER
// ./containers/workWithUsPage/assets/work4.svg
// module id = 0yx2
// module chunks = 0